// Меню

document.addEventListener('DOMContentLoaded', () => {
  const bodyObj = document.querySelector('body')
  const headerLogo = document.querySelector('.header-logo')

  // menu-service
  const menu = document.querySelector('.menu-service')
  const menuOpen = document.querySelector('.menu-service--open')
  const menuClose = document.querySelector('.menu-service--close')
  const headerBtn = document.querySelector('.hide-on-open')
  const headerMenu = document.querySelector('.header-menu')

  function toggleMenu(e) {
    e.stopPropagation()
    menu.classList.toggle('active')

    if (headerMenu.classList.contains('active')) {
      bodyObj.classList.add('overflow')
    } else {
      bodyObj.classList.toggle('overflow')
    }
  }

  menu?.addEventListener('click', toggleMenu)
  menuOpen?.addEventListener('click', toggleMenu)
  menuClose?.addEventListener('click', toggleMenu)

  // menu mobile
  var menuButton = $('.toggle-button'),
    menuMob = $('.header-menu'),
    headerContainer = $('.header-container')

  if (headerContainer) {
    function toggleHeaderBg() {
      if (window.scrollY > 0) {
        headerContainer.addClass('header-container_scroll')
        for (const img of headerLogo.children) {
          if (img.classList.contains('header-logo__white')) {
            img.classList.remove('show')
          } else {
            img.classList.add('show')
          }
        }
      } else {
        headerContainer.removeClass('header-container_scroll')

        for (const img of headerLogo.children) {
          if (img.classList.contains('header-logo__white')) {
            img.classList.add('show')
          } else {
            img.classList.remove('show')
          }
        }
      }
    }

    toggleHeaderBg()
    window.addEventListener('scroll', toggleHeaderBg)
  }

  menuButton.on('click', function () {
    $(this).toggleClass('button-open')
    menuMob.toggleClass('active')

    if (!headerContainer.hasClass('header-container_scroll')) {
      for (const img of headerLogo.children) {
        img.classList.toggle('show')
      }
    }

    headerContainer.toggleClass('background-white')

    if (menu.classList.contains('active')) {
      menu.classList.remove('active')
    }
    headerBtn.classList.toggle('not-active')
    bodyObj.classList.toggle('overflow')
  })
  $(window).keydown(function (e) {
    if (e.keyCode === 27 && $('.header-menu').hasClass('active')) {
      $('.header-menu').removeClass('active')
      $('.toggle-button').removeClass('button-open')
      bodyObj.classList.remove('overflow')
    }
  })
})
